import { EntityModel } from '@/interfaces'
import {
  ALL_EMAIL_CONFIGS_QUERY,
  CREATE_EMAIL_CONFIG_MUTATION,
  DELETE_EMAIL_CONFIG_MUTATION,
  FORCE_DELETE_EMAIL_CONFIG_MUTATION,
  SINGLE_EMAIL_CONFIG_QUERY,
  UPDATE_EMAIL_CONFIG_MUTATION,
} from './graphql'

const tenantEmailConfigModel: EntityModel = {
  name: 'emailConfig',
  namePlural: 'emailConfigs',
  uniqueName: 'tenantEmailConfig',
  uniqueNamePlural: 'tenantEmailConfigs',
  path: 'config/tenant/email_config',
  baseUrl: '/config/tenant/email_configs',
  translationPrefix: 'entities:tenantEmailConfig.',
  getDisplayName: (values: any) => {
    return 'Emails'
  },
  gql: {
    getAll: ALL_EMAIL_CONFIGS_QUERY,
    getSingle: SINGLE_EMAIL_CONFIG_QUERY,
    create: CREATE_EMAIL_CONFIG_MUTATION,
    update: UPDATE_EMAIL_CONFIG_MUTATION,
    delete: DELETE_EMAIL_CONFIG_MUTATION,
    forceDelete: FORCE_DELETE_EMAIL_CONFIG_MUTATION,
  },
  attributes: {
    defaultInternalRecipientEmail: {
      name: 'defaultInternalRecipientEmail',
      label: 'entities:tenantEmailConfig.attributes.defaultInternalRecipientEmail.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'email',
        },
      ],
    },
    internalBookingRecipientEmails: {
      name: 'internalBookingRecipientEmails',
      label: 'entities:tenantEmailConfig.attributes.internalBookingRecipientEmails.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'tags',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'regex',
          pattern:
            /^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,9}|[0-9]{1,3})(\]?)(\s*,\s*|\s*$))*$/,
        },
      ],
    },
    bookingConfirmationTemplateId: {
      name: 'bookingConfirmationTemplateId',
      label: 'entities:tenantEmailConfig.attributes.bookingConfirmationTemplateId.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
    bookingConfirmationInternalTemplateId: {
      name: 'bookingConfirmationInternalTemplateId',
      label: 'entities:tenantEmailConfig.attributes.bookingConfirmationInternalTemplateId.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    bookingRequestConfirmationTemplateId: {
      name: 'bookingRequestConfirmationTemplateId',
      label: 'entities:tenantEmailConfig.attributes.bookingRequestConfirmationTemplateId.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
    bookingWaitlistConfirmationTemplateId: {
      name: 'bookingWaitlistConfirmationTemplateId',
      label: 'entities:tenantEmailConfig.attributes.bookingWaitlistConfirmationTemplateId.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
    bookingWaitlistContingentCheckConfirmationTemplateId: {
      name: 'bookingWaitlistContingentCheckConfirmationTemplateId',
      label: 'entities:tenantEmailConfig.attributes.bookingWaitlistContingentCheckConfirmationTemplateId.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
    bookingCustomRequestTemplateId: {
      name: 'bookingCustomRequestTemplateId',
      label: 'entities:tenantEmailConfig.attributes.bookingCustomRequestTemplateId.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    bookingPassportDataReminderTemplateId: {
      name: 'bookingPassportDataReminderTemplateId',
      label: 'entities:tenantEmailConfig.attributes.bookingPassportDataReminderTemplateId.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    previewTravelInterestTemplateId: {
      name: 'previewTravelInterestTemplateId',
      label: 'entities:tenantEmailConfig.attributes.previewTravelInterestTemplateId.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    contactFormTemplateId: {
      name: 'contactFormTemplateId',
      label: 'entities:tenantEmailConfig.attributes.contactFormTemplateId.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
        {
          type: 'number',
        },
      ],
    },
    esimInstallationInfoTemplateId: {
      name: 'esimInstallationInfoTemplateId',
      label: 'entities:tenantEmailConfig.attributes.esimInstallationInfoTemplateId.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default tenantEmailConfigModel
